export default __webpack_public_path__ + "static/media/bg.ad721f7d.webp";